import React, { forwardRef, useEffect, useState } from "react";
import { Button, Form, Modal, Spinner } from "react-bootstrap";
import { s3FileManagerServices } from "../../../APIServices/SitePilotManagement/s3FileManagerServices";
import { useParams } from "react-router";
import Swal from "sweetalert2";

const DuplicateFolder = forwardRef(({ Show, Hide, Title, sourceKey, getTotalS3Folders }, ref) => {
  const [buttonLoader, setButtonLoader] = useState(false);
  const [name, setName] = useState("");
  const [checkName, setCheckName] = useState("");
  const duplicateS3Folder = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to Duplicate!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, Duplicate it!`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        setButtonLoader(true)
        let userData = {  };
        userData.sourceFolder = `${sourceKey?.[0]}`
        userData.newFolderName = name
        let data = await s3FileManagerServices.duplicateS3Folder(
          userData
        );
        setButtonLoader(false)
        if (data?.statusCode === 200) {
          setName("")
          getTotalS3Folders()
          Hide()
        }
      }
    });
  };

  useEffect(() => {
    if (sourceKey?.length === 1) {
      setName((sourceKey?.[0] || "").split("/").filter(Boolean).pop() || null);
      setCheckName((sourceKey?.[0] || "").split("/").filter(Boolean).pop() || null);
    }
  }, [sourceKey]);

  return (
    <>
      <Modal show={Show} onHide={Hide} placement="end">
        <div ref={ref} className="d-flex flex-column h-100">
          <Modal.Header closeButton>
            <Modal.Title style={{fontSize: 15}}>{Title}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Group className="mb-1">
              <Form.Label className="mb-1 fw-bold">
                Folder Name{" "}
                <abbr title="Required" className="text-danger">
                  *
                </abbr>
              </Form.Label>
              <Form.Control
                type="text"
                rows={3}
                onChange={(e) => setName(e.target.value)}
                value={name}
                className={`fontSize12 ${name === checkName ? "border-danger" : ""}`}
                placeholder="Enter Folder Name"
              />
            </Form.Group>
          </Modal.Body>
          <div className="text-end p-2 border-top">
            <Button
              onClick={duplicateS3Folder}
              disabled={buttonLoader || !name || (name === checkName)}
              title={Title}
              size="sm"
              variant="outline-primary"
            >
              {buttonLoader ? (
                <div className="hstack gap-2">
                  <Spinner size="sm" /> Duplicating...
                </div>
              ) : (
                "Duplicate Now"
              )}
            </Button>
          </div>
        </div>
      </Modal>
    </>
  );
});

export default DuplicateFolder;
